import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Eula } from '../shared/models/eula';
import { SystemUserEulaService } from '../shared/services/system-user-eula.service';

@Component({
  selector: 'app-eula',
  templateUrl: 'eula.component.html',
  styleUrls: ['eula.component.scss'],
})
export class EulaComponent implements OnInit {
  hasLoggedInSystemUserAcceptedLatestEulaSub: Subscription;
  latestEulaInEffectSub: Subscription;
  loggedInSystemUserHasLatestEula: boolean = false;
  latestEulaInEffect: Eula;
  isAcceptanceChecked: boolean = false;
  isLoading: boolean = true;

  constructor(private systemUserEulaService: SystemUserEulaService) {}

  ngOnInit() {
    this.systemUserEulaService.hasLoggedInSystemUserAcceptedLatestEula.subscribe((data) => {
      this.loggedInSystemUserHasLatestEula = data;
    });

    this.systemUserEulaService.latestEulaInEffect.subscribe((data) => {
      this.latestEulaInEffect = data;
      this.systemUserEulaService.getEulaFile().subscribe((response) => {
        let blob = new Blob([response], { type: 'application/pdf' });
        let URL = window.URL || window.webkitURL;
        this.latestEulaInEffect.documentUrl = URL.createObjectURL(blob);
        this.isLoading = false;
      });
    });

    if (!this.loggedInSystemUserHasLatestEula && !this.latestEulaInEffect) {
      this.systemUserEulaService.get_latest_eula();
    }
  }

  downloadEula() {
    if (this.latestEulaInEffect) {
      // create a download anchor tag
      var downloadLink = document.createElement('a');
      downloadLink.target = '_blank';
      downloadLink.download = 'EULA.pdf';

      // set object URL as the anchor's href
      downloadLink.href = this.latestEulaInEffect.documentUrl;

      // append the anchor to document body
      document.body.append(downloadLink);

      // fire a click event on the anchor
      downloadLink.click();

      // cleanup: remove element and revoke object URL
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(this.latestEulaInEffect.documentUrl);
    }
  }

  acceptEula() {
    if (this.latestEulaInEffect && this.isAcceptanceChecked) {
      this.systemUserEulaService.accept_eula(this.latestEulaInEffect);
    }
  }
}
